import NATIONALITIES_TYPES from './nationalities/types';
import GENDERS_TYPES from './genders/types';

export default {
  ...NATIONALITIES_TYPES,
  ...GENDERS_TYPES,
};
